import { CreateMediaInputApiModel } from "@app/store/http/models/input";
import { LandingPageButtonInputApiModel } from "./landing-page-button-input.api-model";

export interface CreateLandingPageInputApiModel {
    title: string;
    person: string;
    slogan: string;
    isPublic?: boolean;
    buttons: LandingPageButtonInputApiModel[];
    header_image?: CreateMediaInputApiModel;
    avatar_image?: CreateMediaInputApiModel;
    is_board_visible?: boolean;
    query_objects: any;
    is_draft?: boolean;
    enable_overlay?: boolean;
    cta?: any;
    is_footnote_visible?: boolean;
    is_public?:boolean
}